<template>
  <li class="item">
    <span class="name">{{ name }}</span>
    <button type="button" @click="emit('select', id)">
      <icon v-if="type === UserContentType.Added" name="trash" />
    </button>
  </li>
</template>
<script lang="ts" setup>
interface Props {
  name: string;
  id: string;
  type: UserContentType;
}

const emit = defineEmits(["select"]);

defineProps({
  name: null,
  id: null,
  type: null
});
</script>
<style lang="scss" scoped>
.item {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: top;
  justify-content: space-between;
  gap: 2rem;
}
.name {
  overflow: hidden;
  text-overflow: ellipsis;
}

button {
  &:hover,
  &:focus {
    color: var(--color_secondary);
  }
}
</style>
